<template>
  <ACLARSLogo     v-if="this.THEME === 'ACLARS'" />
  <ICLRSLogo      v-else-if="this.THEME === 'ICLRS'" />
  <UAELogo        v-else-if="this.THEME === 'UAE'" />
  <IndiaLogo      v-else-if="this.THEME === 'India'" />
  <EthiopiaLogo   v-else-if="this.THEME === 'Ethiopia'" />
  <ICLRSLogo      v-else />
</template>

<script>
import ACLARSLogo from '@/Shared/ACLARSLogo'
import ICLRSLogo from '@/Shared/ICLRSLogo'
import UAELogo from '@/Shared/UAELogo'
import IndiaLogo from '@/Shared/IndiaLogo'
import EthiopiaLogo from '@/Shared/EthiopiaLogo'

export default {
  components: {
    ACLARSLogo,
    ICLRSLogo,
    UAELogo,
    IndiaLogo,
    EthiopiaLogo
},
}
</script>